var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-content"},[_c('router-link',{staticClass:"flex item-center",attrs:{"to":_vm.routes[_vm.$route.name].route || ''}},[_c('icon',{class:_vm.$route.name,attrs:{"name":"back"}}),_c('span',{style:({color: _vm.PAGE_COLORS[_vm.$route.name].cl})},[_vm._v(_vm._s(`All ${_vm.routes[_vm.$route.name].name}`))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }